module.exports = __webpack_public_path__ + "static/media/culturallife.28cf768a.svg";